// extracted by mini-css-extract-plugin
module.exports = {"root":"ContentHeader_root__L2WuA"};